
const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const fetchLeadBalance = async (leadId) => {

    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${API_BASE_URL}/admin/lead/leads/${leadId}/balance`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {

            console.error('Ошибка при получении баланса лида:', response);
            throw new Error(`Ошибка HTTP: ${response.status}`);
        }
        const data = await response.json();
        return data; 
    } catch (error) {
        console.error('Ошибка при запросе баланса лида:', error);
        throw error;
    }
};

